/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileUploadDto } from './FileUploadDto';
import {
    FileUploadDtoFromJSON,
    FileUploadDtoFromJSONTyped,
    FileUploadDtoToJSON,
} from './FileUploadDto';

/**
 * 
 * @export
 * @interface ExamenEntreeFceFichierUploadDto
 */
export interface ExamenEntreeFceFichierUploadDto {
    /**
     * 
     * @type {FileUploadDto}
     * @memberof ExamenEntreeFceFichierUploadDto
     */
    file?: FileUploadDto;
    /**
     * 
     * @type {number}
     * @memberof ExamenEntreeFceFichierUploadDto
     */
    idexamenEntreeFceFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof ExamenEntreeFceFichierUploadDto
     */
    idexamenEntreeFce?: number;
    /**
     * 
     * @type {number}
     * @memberof ExamenEntreeFceFichierUploadDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof ExamenEntreeFceFichierUploadDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof ExamenEntreeFceFichierUploadDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the ExamenEntreeFceFichierUploadDto interface.
 */
export function instanceOfExamenEntreeFceFichierUploadDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExamenEntreeFceFichierUploadDtoFromJSON(json: any): ExamenEntreeFceFichierUploadDto {
    return ExamenEntreeFceFichierUploadDtoFromJSONTyped(json, false);
}

export function ExamenEntreeFceFichierUploadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExamenEntreeFceFichierUploadDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : FileUploadDtoFromJSON(json['file']),
        'idexamenEntreeFceFichier': !exists(json, 'idexamenEntreeFceFichier') ? undefined : json['idexamenEntreeFceFichier'],
        'idexamenEntreeFce': !exists(json, 'idexamenEntreeFce') ? undefined : json['idexamenEntreeFce'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function ExamenEntreeFceFichierUploadDtoToJSON(value?: ExamenEntreeFceFichierUploadDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': FileUploadDtoToJSON(value.file),
        'idexamenEntreeFceFichier': value.idexamenEntreeFceFichier,
        'idexamenEntreeFce': value.idexamenEntreeFce,
        'idfichier': value.idfichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'fileName': value.fileName,
    };
}

